import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=2bd35a03&"
import script from "./NavigationItems.vue?vue&type=script&lang=ts&"
export * from "./NavigationItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports